// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import { media } from '../../../helpers';
import ButtonComponent from '../../button';

const Container = styled<any, Theme>('div')`
  display: none;
  ${media.lg(css`
    display: flex;
  `)}
`;

const FilterCount = styled<any, Theme>('div')`
  width: 1.875rem;
  height: 1.875rem;
  background-color: ${props => props.theme.assortment.activeFiltersButton.backgroundColor};
  color: ${props => props.theme.assortment.activeFiltersButton.color};
  border-radius: 4px;
  text-align: center;
  line-height: 1.875rem;
  font-size: 1.125rem;
`;

const alignment = css`
  text-align: left;
  justify-content: left;
  align-self: center;
`;

// Because the classes are on the same level we use && to give more specifity
// https://www.styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
const Button = styled<typeof ButtonComponent, Theme, _>(ButtonComponent)`
  && {
    padding: 0;
    margin: 0;
    margin-left: 1rem;
    ${media.lg(css`
      display: none;
    `)}
    ${alignment}
}
`;

const FilterButton = styled<typeof ButtonComponent, Theme, _>(ButtonComponent)`
  display: flex;
  width: 100%;
  ${media.sm(css`
    width: auto;
  `)}
  ${media.lg(css`
    display: none;
  `)}
`;

const Text = styled<any, Theme>('p')`
  margin-left: 1rem;
  display: none;
  ${media.lg(css`
    display: block;
  `)}
  ${alignment}
`;

type Props = {|
  count: number,
  onClick: Function,
  filterButtonText: string,
  actionableButtonText: string,
  icon: Node,
|};

const ActiveFiltersButton = ({
  count,
  onClick,
  filterButtonText,
  actionableButtonText,
  icon,
}: Props) => (
  <>
    <Container>
      <FilterCount>
        {count}
      </FilterCount>
      <Text>{filterButtonText}</Text>
      <Button onClick={onClick} variant="link_text">{filterButtonText}</Button>
    </Container>
    <FilterButton onClick={onClick} colors="tertiary" size="small">
      {icon}
      {actionableButtonText}
      {count === 0 ? '' : ` (${count})`}
    </FilterButton>
  </>
);

export default ActiveFiltersButton;
